import { Amplify } from 'aws-amplify';

Amplify.configure({
    Auth: {
        Cognito: {
            // region: "us-east-1",
            // userPoolId: "us-east-1_92bYLuXG4",
            // userPoolClientId: "182mhh2k1lmmn4870e382diuv8",
            region: process.env.REACT_APP_REGION,
            userPoolId: process.env.REACT_APP_USER_POOL_ID,
            userPoolClientId: process.env.REACT_APP_CLIENT_ID,
        }
    }
});
export default Amplify;